document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("newsletter-form");
  const checkbox1 = document.getElementById("input_3.1");
  const responseDiv = document.getElementById("form-response");

  const icon = `<svg xmlns="http://www.w3.org/2000/svg" width="82" height="80" viewBox="0 0 82 80" fill="none">
  <path d="M40.6834 76.3668C60.9431 76.3668 77.3669 59.9431 77.3669 39.6834C77.3669 19.4237 60.9432 3 40.6835 3C20.4237 3 3.99999 19.4237 3.99998 39.6834C3.99997 59.9431 20.4237 76.3668 40.6834 76.3668Z" stroke="#FDB385" stroke-width="3.4" stroke-miterlimit="10"/>
  <path d="M27.0582 37.0668V36.4705C27.3821 35.9338 27.679 35.3673 28.0298 34.8903C28.8394 33.7574 30.2967 33.6679 31.2953 34.8903C32.5097 36.3512 38.1421 42.0327 39.4105 43.4638C40.3821 42.3904 41.3536 41.3469 42.2982 40.3034C44.4842 37.8885 49.9801 32.1337 52.1931 29.7187C53.0028 28.8243 54.1092 28.7647 54.8919 29.5399C55.4856 30.1361 56.0793 30.7324 56.2413 31.6567V32.1337C55.9984 32.6107 55.8365 33.1772 55.4856 33.535C51.7613 37.709 44.6731 45.1632 40.9218 49.3074C39.9773 50.3509 38.8708 50.3509 37.9262 49.3074C36.091 47.28 29.9189 40.9128 28.0838 38.8854C27.598 38.3488 27.1662 37.8121 27.0312 37.0668H27.0582Z" fill="#FDB385"/>
</svg>`;

  if (!form || !checkbox1 || !responseDiv) {
    return;
  }

  form.addEventListener("submit", function (event) {
    event.preventDefault();

    if (!checkbox1.checked) {
      responseDiv.innerHTML =
        '<p class="error text-orange mt-2 fs-16">Musisz zaznaczyć checkbox, aby wysłać formularz.</p>';
      return;
    }

    const formDataNewsletter = new FormData(form);

    fetch("/wp-json/wl/v1/posts", {
      method: "POST",
      body: formDataNewsletter,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Wiadomość: ", data.message);
        if (data.message) {
          console.log("Wiadomość: ", data.message);
        } else {
          console.log("Dane nie zostały wysłane.");
        }
      })
      .catch((error) => {
        console.log("Błąd podczas wysyłania danych.");
        console.error("Błąd AJAX:", error);
      });

    const formData = new FormData(form);

    fetch("/wp-json/ahr/v1/forms", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.entry_id) {
          responseDiv.innerHTML = `<p class="success text-orange m-0 fs-24 fw-500 d-flex align-items-center gap-3 flex-lg-row flex-column mt-7 mt-lg-0">${icon} Formularz został wysłany pomyślnie!</p>`;
          form.classList.add("d-none");
        } else {
          responseDiv.innerHTML =
            '<p class="error text-white fs-12">Wystąpił błąd podczas wysyłania formularza: skontaktuj się z nami fho@fho.org.pl</p>';
        }
      })
      .catch((error) => {
        responseDiv.innerHTML =
          '<p class="error text-white fs-12">Wystąpił błąd podczas połączenia z serwerem. Spróbuj ponownie.</p>';
        console.error("Błąd AJAX:", error);
      });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const postalCodeField = document.querySelector(".kod-pocztowy input");

  if (postalCodeField) {
    postalCodeField.addEventListener("input", function (e) {
      this.value = this.value.replace(/[^0-9]/g, "");

      if (this.value.length > 2 && this.value.length <= 6) {
        this.value = this.value.slice(0, 2) + "-" + this.value.slice(2, 6);
      }
      if (this.value.length > 6) {
        this.value = this.value.slice(0, 6);
      }
    });
  }
});

function isValidNip(nip) {
  if (typeof nip !== "string") {
    return false;
  }

  nip = nip.replace(/[\ \-]/g, "");

  if (nip.length !== 10 || !/^\d+$/.test(nip)) {
    return false;
  }

  let weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  let sum = 0;

  let controlNumber = parseInt(nip.substring(9, 10));

  for (let i = 0; i < weight.length; i++) {
    sum += parseInt(nip.substr(i, 1)) * weight[i];
  }

  return sum % 11 === controlNumber;
}

document.addEventListener("DOMContentLoaded", function () {
  const nipField = document.querySelector(".nip input");

  if (nipField) {
    nipField.addEventListener("input", function () {
      this.value = this.value.replace(/[^0-9]/g, "");
    });

    nipField.addEventListener("blur", function () {
      if (!isValidNip(this.value)) {
        this.style.borderColor = "red";
        this.style.color = "red";
      } else {
        this.style.borderColor = "#004542";
        this.style.color = "#004542";
      }
    });
  }
});

function openPopupRodo() {
  const consentFields = [
    document.querySelector(".data-processing-consent"),
    document.querySelector(".data-processing"),
  ];
  const popup = document.querySelector(".popup-rodo");
  let closeButton;
  if (popup?.querySelector(".close")) {
    closeButton = popup?.querySelector(".close");
  }

  if (popup) {
    consentFields.forEach(function (consentField) {
      if (consentField) {
        consentField.addEventListener("click", function () {
          if (popup.classList.contains("d-none")) {
            popup.classList.remove("d-none");
          }
        });
      }
    });

    if (closeButton) {
      closeButton.addEventListener("click", function () {
        if (!popup.classList.contains("d-none")) {
          popup.classList.add("d-none");
        }
      });
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !popup.classList.contains("d-none")) {
        popup.classList.add("d-none");
      }
    });
  }
}
document.addEventListener("DOMContentLoaded", openPopupRodo);
